import * as React from 'react';

export const Spacer = () => <span style={{width: 16}} />;
